export const AccountingCellRenderer = ({ value, colDef }) => {
  if (value == null) {
    return <span />;
  }

  const numericValue = Number(value);
  const absValue = Math.abs(numericValue);

  const formatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'USD',
    minimumFractionDigits: colDef.decimalPrecision,
    maximumFractionDigits: colDef.decimalPrecision,
  });

  const formatted = formatter.format(absValue);
  const valueStr = numericValue < 0 ? '(' + formatted + ')' : formatted;

  return (
    <span cell-value={value} title={value} style={{  display: 'flex', justifyContent: 'flex-end' }}>
      {valueStr}
    </span>
  );
}